import React, { useState, useEffect, useRef, useMemo } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';

// import SunEditor from 'suneditor-react';
// import 'suneditor/dist/css/suneditor.min.css';
import GeneralUtils from '../../utilities/GeneralUtils';
import EnumService from '../../service/EnumService';
import { Dropdown } from 'primereact/dropdown';
import { AutoComplete } from 'primereact/autocomplete';
import { RecruitmentService } from '../../service/RecruitmentService';

const emptyRecord = {
    id: null,
    jobID: '',
    recruitmentPlanJob: null,
    location: '',
    jobCounty: null,
    workingHours: null,
    jobDuty: '',
    name: '',
    institution: null,
};

const JobEditDialog = (props) => {
    const [job, setJob] = useState(emptyRecord);
    const [isNew, setIsNew] = useState(false);
    const [jobs, setJobs] = useState([]);
    const [counties, setCounties] = useState([])
    // const [workingHoursList, setWorkingHoursList] = useState([])
    const [filteredentityLookups, setFilteredentityLookups] = useState([]);
    const [institutions, setInstitutions] = useState([]);
    const [isTempJobCompetition, setIsTempJobCompetition] = useState(false);

    const toast = useRef(null);
    const competitionService = useMemo(() => new CompetitionService(), []);
    const recruitmentService = useMemo(() => new RecruitmentService(), []);

    useEffect(() => {
        // console.log(props?.value)
        let _job = props?.value
            ? GeneralUtils.emptyInNullForObjectFields(props?.value)
            : { ...emptyRecord, competition: props?.competition, institution: props?.competition?.institution };

        setIsNew(props?.value ? false : true);

        const getCounty = async () => {
            const _counties = await EnumService.getEntityLookupByField("NOM:COUNTY")
            setCounties(_counties)
        }

        // const getWorkingHours = async () => {
        //     const _workingHoursList = await EnumService.getEntityLookupByField("NOM:WORKING_HOURS")
        //     setWorkingHoursList(_workingHoursList)
        // }

        const computeJob = async () => {
            if (_job.id) {
                _job.jobCounty = { ..._job.jobCounty, value: _job.jobCounty?.id }
                // _job.workingHours = _job.workingHours?.id
            }

            // console.log(_job);            
            setJob(_job);
            // await getWorkingHours()
            await getCounty()
        }

        computeJob()
        setInstitutions(props.institutions);
        setIsTempJobCompetition(props?.competition.positionCategory === "FUNCTII_PUBLICE_DE_EXECUTIE_TEMP")

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        formik.resetForm();
    };

    const getJobs = async (e = null) => {
        let criteria = {};
        criteria.jobID = e?.query;

        if (props?.competition?.id) {
            await recruitmentService.getRecruitmentPlanJobListForCompetition(props?.competition?.id, formik.values.institution?.id, criteria)
                .then((data) => {
                    // console.log("job list: ", data.items);
                    // console.log("existingJobs: ", props?.existingJobs);
                    if (data?.items?.length === 0) {
                        toast?.current?.show({ severity: 'error', summary: translatedMessage('competition.job.jobID.notFound'), life: 5000 })
                    }

                    let _existingJobs = []
                    let checkField = 'jobID';
                    props?.existingJobs.forEach(item => {
                        if (item.jobID) {
                            if(item.jobID !== job.jobID) {
                                _existingJobs.push(item);
                            }
                        } else {
                            if(item.id !== job.id) {
                                _existingJobs.push( {...item, id: item.recruitmentPlanJob.id} );
                                checkField = 'id';
                            }
                        }
                    })

                    let _jobs = GeneralUtils.filterItemsNotInOtherArray(data.items, _existingJobs, checkField)
                    if(data?.items?.length !== 0 && _jobs.length === 0) {
                        toast?.current?.show({ severity: 'error', summary: translatedMessage('competition.job.allJobsAdded'), life: 5000 })
                    }
                    setJobs(_jobs);
                    return _jobs;
                })
                .catch((error) => {
                    toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 })
                });
        }
    };

    const saveJob = (data) => {
        competitionService.saveJob(data)
            .then((savedJob) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(savedJob, true, null);
                }
                hideDialog();
            })
            .catch((error) => {
                // console.log("error: ", error);
                props.afterSave(null, false, error);
            });
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: job ? job : { ...emptyRecord, competition: props?.competition },
        validate: (data) => {
            let errors = {};

            // console.log("validate job: ", data);

            if (isTempJobCompetition) {
                if (!data.jobID || data.jobID.trim() === '') {
                    errors.recruitmentPlanJob = translatedMessage('form.error.job.jobID.required');
                }
            } else {
                if (data.institution?.secret) {
                    if (!data.recruitmentPlanJob || !data.recruitmentPlanJob.id) {
                        errors.recruitmentPlanJob = translatedMessage('form.error.job.jobID.required');
                    }
                } else {
                    if (!data.recruitmentPlanJob || !data.recruitmentPlanJob.jobID) {
                        errors.recruitmentPlanJob = translatedMessage('form.error.job.jobID.required');
                    }
                }
            }

            if (!data.location || data.location.trim() === '') {
                errors.location = translatedMessage('form.error.job.location.required');
            }
            if (!data.jobCounty) {
                errors.jobCounty = translatedMessage('form.error.county.required');
            }
            // if (!data.workingHours) {
            //     errors.workingHours = translatedMessage('form.error.job.workingHours.required');
            // }
            // if (!data.jobDuty || data.jobDuty.trim() === '') {
            //     errors.jobDuty = translatedMessage('form.error.job.jobDuty.required');
            // } else {
            //     if (!GeneralUtils.nullIfEmptyHTMLEditor(data.jobDuty) || GeneralUtils.nullIfEmptyHTMLEditor(data.jobDuty).length < 10) {
            //         errors.jobDuty = translatedMessage('form.error.job.jobDuty.minLength');
            //     }
            // }
            if (!data.institution?.id) {
                errors.institution = translatedMessage('form.error.competition.institution.required');
            }

            return errors;
        },
        onSubmit: (data) => {
            let _data = { ...GeneralUtils.nullIfEmptyForObjectFields(data) };
            // _data.workingHours = { id: data.workingHours }
            _data.jobCounty = { id: data.jobCounty.value }
            _data.institution = { id: data.institution?.id }
            _data.competition = { id: data.competition?.id }
            if (isTempJobCompetition) {
                _data.recruitmentPlanJob = null
            } else {
                _data.nomInstitutionJob = null
                _data.jobID = data.recruitmentPlanJob.jobID
            }
            // console.log("job saved: ", _data);
            saveJob(_data);
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const formDialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-save" className="p-button-text" form="field-form" type="submit" />
        </>
    );

    const handleSelectChange = (data, resetValues = true) => {
        // console.log("handleSelectChange", data)
        let _targetField = data?.target?.id

        if (_targetField) {
            formik.setFieldValue(_targetField, data.value)
        }
    }

    const jobTemplate = (_job) => {
        // console.log("jobTemplate", _job)
        if (isTempJobCompetition) {
            return (
                _job.jobID +
                (_job.departmentType ? (" - " + _job.departmentType) : "") +
                (_job.departmentName ? (" - " + _job.departmentName) : "") +
                (_job.position ? (" - " + _job.position) : "") +
                (_job.jobClass ? (" - " + _job.jobClass) : "") +
                (_job.level ? (" - " + _job.level) : "")
            )
        } else {
            return (
                (_job.jobID ? _job.jobID : "N/A") +
                (_job.departmentType ? (" - " + _job.departmentType) : "") +
                (_job.departmentName ? (" - " + _job.departmentName) : "") +
                (_job.position ? (" - " + _job.position) : "") +
                (_job.positionClass ? (" - " + _job.positionClass) : "") +
                (_job.positionLevel ? (" - " + _job.positionLevel) : "") +
                (_job.jobID ? "" : (" (" + _job.id + ")"))
            )
        }
    }

    const searchListItems = (event, list) => {
        let query = event.query;
        let _filteredItems = [];

        for (let i = 0; i < list.length; i++) {
            let item = list[i];
            if (item.label.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                _filteredItems.push(item);
            }
        }

        setFilteredentityLookups(_filteredItems);
    }

    const handleListChange = async (data, field) => {
        // console.log("handleListChange")
        formik.setFieldValue(field, data.value)
    }

    // const setJobDutyValue = (_jobDuty) => {
    //     formik.setFieldValue('jobDuty', _jobDuty);
    // }

    const handleDropdownChange = (data) => {
        // console.log("handleDropdownChange: ", data)
        let _targetField = data?.target?.id
        formik.setFieldValue(_targetField, data.value);
        if (_targetField === "institution.id") {
            formik.setFieldValue("recruitmentPlanJob", null);
        }
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={props?.visible}
                header={translatedMessage(isNew ? 'job.add' : 'job.edit')}
                modal
                className="pcn-dialog"
                footer={formDialogFooter}
                onHide={hideDialog}
            >
                <form id="field-form" onSubmit={formik.handleSubmit}>
                    <div className='grid'>
                        <div className='col-12'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <Dropdown
                                        id="institution.id"
                                        name="institution.id"
                                        value={formik.values.institution?.id}
                                        onChange={handleDropdownChange}
                                        options={institutions}
                                        itemTemplate={(e) => e.label}
                                        scrollHeight="400px"
                                        className={classNames({ 'p-invalid': isFormFieldValid('institution') })}
                                    />
                                    <label htmlFor="institution.id" className={classNames({ 'p-error': isFormFieldValid('institution') })}>
                                        {translatedMessage('competition.institution')} *
                                    </label>
                                </span>
                            </div>
                            {getFormErrorMessage('institution')}
                        </div>

                        <div className='col-12'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    {!isTempJobCompetition &&
                                        <AutoComplete
                                            dropdown
                                            id="recruitmentPlanJob"
                                            name="recruitmentPlanJob"
                                            value={formik.values.recruitmentPlanJob}
                                            suggestions={jobs}
                                            completeMethod={(e) => getJobs(e)}
                                            virtualScrollerOptions={{ itemSize: 38 }}
                                            field="recruitmentPlanJob"
                                            itemTemplate={(e) => jobTemplate(e)}
                                            selectedItemTemplate={(e) => jobTemplate(e)}
                                            onChange={handleSelectChange}
                                            emptyMessage={translatedMessage('job.recruitmentPlan.emptyMessage')}
                                            className={classNames({ 'p-invalid': isFormFieldValid('recruitmentPlanJob') })}
                                        />
                                    }

                                    {isTempJobCompetition &&
                                        <InputText type="text" name="jobID" id="jobID"
                                            value={formik.values.jobID} onChange={formik.handleChange}
                                            className={classNames({ 'p-invalid': isFormFieldValid('recruitmentPlanJob') })}
                                        />
                                    }

                                    <label htmlFor={isTempJobCompetition ? "jobID" : "recruitmentPlanJob"} className={classNames({ 'p-error': isFormFieldValid('recruitmentPlanJob') })}>
                                        {translatedMessage("job.jobID")} *
                                    </label>
                                </span>
                            </div>
                            {getFormErrorMessage('recruitmentPlanJob')}
                            {isTempJobCompetition && formik.values.id &&
                                <div className='mt-2 mb-2 font-bold text-ligh-grey'>{jobTemplate(job)}</div>
                            }

                        </div>

                        {/* <div className='col-12'><Divider className='mt-0 mb-0' /></div> */}

                        <div className='col-12 md:col-6'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <InputText type="text" name="location" id="location"
                                        value={formik.values.location} onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('location') })}
                                    />
                                    <label htmlFor="location" className={classNames({ 'p-error': isFormFieldValid('location') })}>
                                        {translatedMessage("job.location")} *
                                    </label>
                                </span>
                            </div>
                            {getFormErrorMessage('location')}
                        </div>

                        <div className='col-12 md:col-6'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <AutoComplete
                                        dropdown
                                        id="jobCounty"
                                        name="jobCounty"
                                        value={formik.values.jobCounty}
                                        suggestions={filteredentityLookups}
                                        completeMethod={(e) => searchListItems(e, counties)}
                                        virtualScrollerOptions={{ itemSize: 38 }}
                                        field="label"
                                        onChange={(d) => handleListChange(d, "jobCounty")}
                                        emptyMessage={translatedMessage('generic.tableEmptyMessage')}
                                        className={classNames({ 'p-invalid': isFormFieldValid('jobCounty') })}
                                    />
                                    <label htmlFor="jobCounty" className={classNames({ 'p-error': isFormFieldValid('jobCounty') })}>
                                        {translatedMessage("generic.county")}*
                                    </label>
                                </span>
                            </div>
                            {getFormErrorMessage('jobCounty')}
                        </div>

                        {/* <div className='col-12 md:col-6'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <Dropdown
                                        id="workingHours"
                                        name="workingHours"
                                        value={formik.values.workingHours}
                                        options={workingHoursList}
                                        onChange={(e) => formik.setFieldValue("workingHours", e.value)}
                                    />
                                    <label htmlFor="workingHours" className={classNames({ 'p-error': isFormFieldValid('workingHours') })}>
                                        {translatedMessage('job.workingHours')} *
                                    </label>
                                </span>
                            </div>
                            {getFormErrorMessage('workingHours')}
                        </div> */}

                        {/* <div className='col-12 '>
                            <div className="field pcn-sun-editor w-100 mb-0">
                                <label htmlFor="description">{translatedMessage('job.jobDuty')} *</label>
                                <SunEditor
                                    id="jobDuty" name="jobDuty"
                                    lang={LanguageService.getCurrentLanguage()}
                                    height="200px"
                                    width='auto'
                                    defaultValue={formik.values.jobDuty}
                                    placeholder={""}
                                    setOptions={{
                                        buttonList: GeneralUtils.getSunEditorButtons(),
                                        font: GeneralUtils.getSunEditorFonts(),
                                        defaultStyle: GeneralUtils.getSunEditorDefaultStyle(),
                                        charCounter: ApiService.getIsProduction() ? true : false,
                                        maxCharCount: ApiService.getIsProduction() ? 10000 : null
                                    }}
                                    onChange={setJobDutyValue}
                                />
                                {getFormErrorMessage('jobDuty')}
                            </div>
                        </div> */}



                    </div>
                </form>
            </Dialog >
        </>
    );
};

export default JobEditDialog;
